import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { DailyPoint, DashboardPayload, SeriesPoint, SnapshotMeta } from '@/api/dashboard-live';
import type { ChartPalette } from './theme';

export interface Detail {
  title: string;
  subtitle?: string;
  /** « Comment c'est calculé » : texte affiché en tête du panneau */
  explain?: ReactNode;
  body?: ReactNode;
}

export interface PilotageState {
  payload: DashboardPayload;
  snapshot: SnapshotMeta;
  /** séries fines (24 h glissantes en direct, la journée en mode historique) */
  series: Record<string, SeriesPoint[]>;
  /** historique journalier (90 jours jusqu'au jour affiché) */
  daily: Record<string, DailyPoint[]>;
  isLive: boolean;
  day: string;
  palette: ChartPalette;
  dark: boolean;
  /** horloge (rafraîchie toutes les 30 s) pour les « il y a… » */
  now: number;
  openDetail: (detail: Detail) => void;
}

export const PilotageContext = createContext<PilotageState | null>(null);

export function usePilotage(): PilotageState {
  const ctx = useContext(PilotageContext);
  if (!ctx) throw new Error('usePilotage hors de PilotageContext');
  return ctx;
}

/** Dernière valeur journalière d'un indicateur avant le jour affiché (comparaison « vs hier ») */
export function previousDayValue(daily: Record<string, DailyPoint[]>, metric: string, day: string): number | null {
  const points = daily[metric] ?? [];
  for (let i = points.length - 1; i >= 0; i--) {
    if (points[i].d < day) return points[i].v;
  }
  return null;
}
